import React, { useState } from 'react';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { useProjectModel } from '../../../model.js';
import { generateEvent } from './generate.js';
import { ChooseFolderStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateEvent = () => {
  const { model } = useProjectModel();
  const [eventFolder, setEventFolder] = useState<string>();

  const generationTask = useGenerationTask(async () => {
    if (eventFolder) {
      return generateEvent(model.projectFolder, eventFolder);
    }
  }, [model.projectFolder, eventFolder]);

  return [
    <ChooseFolderStep onSubmit={setEventFolder} eventFolder={eventFolder} />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'event'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        learnMoreUrl: 'https://dev.wix.com/docs/go-headless',
      })}
      route={eventFolder}
    />,
  ];
};
